<template>
    <div class="containerRepresentante">
        <DeclaracoesDocumentosList
            tipoClienteKey="Pessoa Jurídica"
            :showStatusButton="true"
            :showRefresh="true"
            :useImpressaoFlag="true"
            :enablePolling="true"
        >
            <template #modals>
                <ModalInformativoDocumentosDeclaracoes_PJ_Fundos :guidDocumento="guidDocumento" />
                <ModalStatusAssinatura />
            </template>
        </DeclaracoesDocumentosList>
    </div>
</template>

<script>
import DeclaracoesDocumentosList from '@/components/Declaracoes/DeclaracoesDocumentosList.vue';
import ModalInformativoDocumentosDeclaracoes_PJ_Fundos from '../Documentos/ModalInformativoDocumentosDeclaracoes_PJ_Fundos.vue';
import ModalStatusAssinatura from '../Documentos/ModalStatusAssinaturaDeclaracoes_PJ_Fundos.vue';

export default {
    name: 'CadastroPF_Representantes',
    props: ['Edicao'],
    components: { DeclaracoesDocumentosList, ModalInformativoDocumentosDeclaracoes_PJ_Fundos, ModalStatusAssinatura },
    data() {
        return {
            guidDocumento: '',
        };
    },
};
</script>

<style lang="scss" scoped>
</style>